import { CancelToken, CancelTokenSource } from 'axios';

export class Service {
  private static _calls: { [key: string]: CancelTokenSource } = {};

  protected static setCall(key: string, value: CancelTokenSource): CancelToken {
    if (Service._calls[key]) {
      Service._calls[key].cancel();
    }
    Service._calls[key] = value;
    return value.token;
  }

  protected static cancelRequest = (caller: string): void => {
    if (Service._calls[caller]) {
      Service._calls[caller].cancel();
      delete Service._calls[caller];
    }
  };
}
